





















import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";

@Component({})
export default class RadioGroup extends Vue {
  @Prop({ default: "" }) label!: string;
  @Prop({ default: null }) value!: boolean | number;
  @Prop({
    default() {
      return { value: true, name: "Tak" };
    }
  })
  value1!: {
    value: boolean | number;
    name: string;
  };
  @Prop({
    default() {
      return { value: false, name: "Nie" };
    }
  })
  value2!: {
    value: boolean | number;
    name: string;
  };
  @Prop({
    default() {
      return { value: null, name: "Dowolna wartość" };
    }
  })
  value3!: {
    value: boolean | number;
    name: string;
  };

  get localValue(): number {
    if (this.value === this.value1.value) {
      return 1;
    } else if (this.value === this.value2.value) {
      return 0;
    } else {
      return -1;
    }
  }

  set localValue(value: number) {
    if (value === 1) {
      // this.value = this.value1.value;
      this.$emit("input", this.value1.value);
    } else if (value === 0) {
      this.$emit("input", this.value2.value);
    } else {
      this.$emit("input", this.value3.value);
    }
  }
}
